<template>
    <div
        :class="buttonClass"
        @mouseover="buttonOver"
        @mouseleave="buttonLeave"
        @click="emitEvent({ name: 'add-to-favorites-click' })"
    >
        <common-icon name="heart" size="small"></common-icon>
        {{ $t('common.microcopy.favorites') }}
    </div>
</template>

<script>
    import WindowResizeMixin from 'mixins/WindowResizeMixin'

    export default {
        mixins: [WindowResizeMixin],

        props: {
            isFavorites: { type: Boolean, default: false },
        },

        data: () => ({
            isMouseOver: false,
        }),

        computed: {
            buttonClass() {
                return {
                    'favorites-button': true,
                    'favorites-button__not-favorites': this.isMouseOver && !this.isTablet && !this.isFavorites,
                    'favorites-button__favorites': this.isFavorites || (this.isMouseOver && !this.isTablet),
                }
            },
        },

        methods: {
            buttonOver() {
                this.isMouseOver = true
            },

            buttonLeave() {
                this.isMouseOver = false
            },
        },
    }
</script>
